//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
import { useEffect, useState } from "react";

// Material ui Imports
import { SxProps } from "@mui/system";
import { Grid, Typography, styled, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/SearchRounded";

// Custom components imports (and hooks and helpers)
import { VTButton, VTTextField, VTTypography, VTUserSelectTable } from "@virtus-tech-repository/virtus-tech-repository";

// Media imports

import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { DateCalendar, DateField, LocalizationProvider } from "@mui/x-date-pickers";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { UserAttemptRowObjectType } from "@virtus-tech-repository/virtus-tech-repository/lib/components/VTTableBasic";
import { useGetScenarioAttemptsQuery, useGetUserAttemptsQuery } from "../../services/tracking.service";
import { Params, useParams } from "react-router-dom";
import { setSelectedAttempt, setSelectedUser } from "../../store/slices/current.slice";
export const TemplateSceneImg = styled("img")(({ theme }) => ({
    borderRadius: "15px",
    height: "200px",
    width: "100%",
    objectFit: "cover",
    ":hover": {
        cursor: "pointer",
    },
}));

//---------------------------------------------------------------------------------------------------
// ## INTERFACES ##
interface IProps {
    sx?: SxProps;
}

export default function VTUsersSidePanel({ sx }: IProps) {
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE ##

    const dispatch = useAppDispatch();
    const theme = useTheme();
    const { id: userId } = useAppSelector((state) => state.userReducer);
    const { scenarioId }: Readonly<Params<string>> = useParams();
    const [searchValue, setSearchValue] = useState<string>("");

    const [dateShow, setDateShow] = useState<boolean>(true);
    const [startDate, setStartDate] = useState<Dayjs>(dayjs("2022-04-17"));

    const [endDate, setEndDate] = useState<Dayjs>(dayjs("2022-04-17"));
    const { selectedUser } = useAppSelector((state) => state.currentReducer);
    const { data: tracking } = useGetScenarioAttemptsQuery({ scenarioId: scenarioId });

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="flex-start"
            sx={{
                height: "calc(100vh - 70px)",
                padding: "10px",
                width: "100%",
                paddingTop: "10px",
                overflowY: "auto",
                ...sx,
            }}
        >
            {/*-----------------------------------------------------------------------------------------*/}
            {/* Images search */}

            <Grid item xs={11}>
                <VTTextField
                    placeholder={"Search Users"}
                    sx={{
                        marginTop: "20px",
                    }}
                    value={searchValue}
                    onChange={(textInput: string) => setSearchValue(textInput)}
                    type={"text"}
                    endIcon={<SearchRoundedIcon />}
                />
            </Grid>
            <Grid
                item
                xs={12}
                container
                justifyContent={"center"}
                alignContent={"flex-start"}
                sx={{ height: "calc(100vh - 230px)", overflowY: "auto" }}
            >
                {tracking && (
                    <VTUserSelectTable
                        sx={{ marginInline: "5px" }}
                        tableData={[
                            ...tracking
                                .filter((element: any) => element.email.split("@")[0].includes(searchValue))
                                .map((element: any) => {
                                    return {
                                        id: element.id,
                                        name: element.email.split("@")[0],
                                    } as UserAttemptRowObjectType;
                                }),
                        ]}
                        onRowSelected={(e: any) => {
                            const selectedItem = tracking.find(
                                (findElement: any) => findElement.email.split("@")[0] === e.name,
                            )!;
                            if (selectedItem) {
                                dispatch(setSelectedUser(selectedItem));
                            }
                        }}
                        selectedId={selectedUser ? [selectedUser.id] : []}
                    />
                )}
            </Grid>
        </Grid>
    );
}
